import React, { useState, useEffect } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import styled from "styled-components";
import {
  ChevronRight,
  ChevronLeft,
  Home,
  CircleUser,
  LogOut,
  X,
} from "lucide-react";
import "../../Common/NavBar/NavBar.scss";
import { useAuth } from "../../../contexts/AuthContext";

const Popup = styled.div.attrs({ className: "popup-mainmenu" })`
  position: fixed;
  overflow-x: hidden;
  background-color: #ffffff;
  z-index: 100;
  box-shadow: -2px 0 5px rgba(0, 0, 0, 0.2);
`;

const Overlay = styled.div.attrs({ className: "overlay" })`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.4);
  z-index: 99;
`;

const menu = [
  { label: "Home", path: "/", icon: "home" },
  { label: "About Us", path: "/about" },
  {
    label: "Gallery",
    path: "/physicals",
    hasSub: true,
    subItems: [
      { label: "Physical", path: "/physicals" },
      { label: "Digital", path: "/digitals" },
    ],
  },
  { label: "Creators", path: "/creators" },
  {
    label: "Historical Project",
    path: "/reproduction",
    hasSub: true,
    subItems: [
      { label: "Artworks", path: "/reproduction" },
      { label: "Archive", path: "/archive" },
      { label: "Physical Editions", path: "/physical-editions" },
      { label: "Posters", path: "/posters" },
    ],
  },
  { label: "Media", path: "/media" },
  {
    label: "Legal",
    path: "/legal/buyer-guarantee",
    hasSub: true,
    subItems: [
      { label: "Buyer Guarantee", path: "/legal/buyer-guarantee" },
      { label: "Terms of use", path: "/legal/terms-of-use" },
    ],
  },
  { label: "Sign-in", path: "/auth" },
];

const PopupMenu = ({ marginTop, togglePopup }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const { isAuthenticated, logout } = useAuth();
  const [activeMain, setActiveMain] = useState(null);
  const [activeSub, setActiveSub] = useState(null);
  const [subView, setSubView] = useState(false);

  useEffect(() => {
    let foundMain = location.pathname === "/profile" ? "Profile" : null;
    let foundSub = null;

    menu.forEach((item) => {
      if (item.subItems) {
        const found = item.subItems.find(
          (sub) => sub.path === location.pathname,
        );
        if (found) {
          foundMain = item.label;
          foundSub = found.label;
        }
      } else if (item.path === location.pathname) {
        foundMain = item.label;
      }
    });

    setActiveMain(foundMain);
    setActiveSub(foundSub);
    setSubView(false);
  }, [location.pathname]);
  useEffect(() => {
    document.body.style.overflow = "hidden";

    return () => {
      document.body.style.overflow = "auto";
    };
  }, []);
  const openSub = (item) => {
    if (item.hasSub) {
      setActiveMain(item.label);
      setSubView(true);
    }
  };

  const chooseSub = (sub) => {
    setActiveSub(sub.label);
    setSubView(false);
    navigate(sub.path);
    togglePopup();
  };

  const clickMain = (item) => {
    if (!item.hasSub) {
      setActiveMain(item.label);
      navigate(item.path);
      togglePopup();
    } else {
      openSub(item);
    }
  };
  return (
    <>
      <Overlay className="active" onClick={togglePopup} />
      <Popup style={{ marginTop }}>
        {!subView && (
          <ul className="popup-menu-container">
            {isAuthenticated && (
              <li className="pop_link-btn desktop-only">
                <Link to="/profile" onClick={togglePopup}>
                  <p className="pop-up-text">Profile</p>
                </Link>
              </li>
            )}
            <li className="pop_link-btn desktop-only">
              {isAuthenticated ? (
                <>
                  <p
                    className="pop-up-text logout"
                    onClick={() => {
                      logout();
                      togglePopup();
                    }}
                  >
                    Logout
                  </p>
                </>
              ) : (
                <Link to="/auth" onClick={togglePopup}>
                  <p className="pop-up-text">Log-in</p>
                </Link>
              )}
            </li>
            <div className="mobile-only">
              {menu.map((item, i) => {
                if (isAuthenticated && item.label === "Sign-in") {
                  return null;
                }

                if (!isAuthenticated && item.label === "Sign-in") {
                  return (
                    <li
                      key={i}
                      className="menu-row"
                      onClick={() => {
                        setActiveMain("Sign-in");
                        setActiveSub(null);
                        navigate("/auth");
                        togglePopup();
                      }}
                    >
                      <span
                        className={`dot33 ${activeMain === "Sign-in" ? "active" : ""}`}
                      />
                      <div className="menu-content">
                        <span
                          className={`menu-link ${activeMain === "Sign-in" ? "underline2" : ""}`}
                          style={{
                            color: "#e56b2f",
                          }}
                        >
                          Sign-in
                        </span>
                      </div>
                      <div className="menu-icon">
                        <CircleUser className="svg" size={18} />
                      </div>
                    </li>
                  );
                }

                return (
                  <li key={i} className="menu-row">
                    <span
                      className={`dot33 ${activeMain === item.label ? "active" : ""}`}
                    />

                    <div
                      className="menu-content"
                      onClick={() => clickMain(item)}
                    >
                      <span
                        className={`menu-link ${activeMain === item.label && activeSub ? "underline2" : ""}`}
                      >
                        {item.label}
                      </span>

                      {activeMain === item.label && activeSub && (
                        <div className="submenu">‹ {activeSub}</div>
                      )}
                    </div>

                    {item.hasSub && (
                      <div
                        className="menu-icon clickable"
                        onClick={() => openSub(item)}
                      >
                        <ChevronRight size={20} className="svg" />
                      </div>
                    )}

                    {item.icon === "home" && (
                      <Home className="svg2" size={18} />
                    )}
                  </li>
                );
              })}

              {isAuthenticated && (
                <>
                  <li
                    className="menu-row"
                    onClick={() => {
                      setActiveMain("Profile");
                      setActiveSub(null);
                      navigate("/profile");
                      togglePopup();
                    }}
                  >
                    <span
                      className={`dot33 ${activeMain === "Profile" ? "active" : ""}`}
                    />
                    <div className="menu-content">
                      <span
                        className={`menu-link ${activeMain === "Profile" ? "underline2" : ""}`}
                      >
                        Profile
                      </span>
                    </div>
                    <div className="menu-icon">
                      <CircleUser className="svg" size={18} />
                    </div>
                  </li>

                  <li
                    className="menu-row"
                    onClick={() => {
                      logout();
                      togglePopup();
                    }}
                  >
                    <span className="dot33" />
                    <div className="menu-content">
                      <span className="menu-link logout">Logout</span>
                    </div>
                    <div className="menu-icon">
                      <LogOut className="svg" size={18} />
                    </div>
                  </li>
                </>
              )}
            </div>
          </ul>
        )}

        {subView && (
          <ul className="popup-menu-container">
            <li className="menu-row back" onClick={() => setSubView(false)}>
              <div className="menu-icon clickable">
                <ChevronLeft className="svg" size={20} />
              </div>
              <span className="menu-link">{activeMain}</span>
            </li>

            {menu
              .find((item) => item.label === activeMain)
              ?.subItems?.map((sub, i) => (
                <li key={i} className="menu-row" onClick={() => chooseSub(sub)}>
                  <span
                    className={`dot33 ${
                      activeSub === sub.label ? "active" : ""
                    }`}
                  />

                  <div className="menu-content">
                    <span
                      className={`menu-link ${
                        activeSub === sub.label ? "underline2" : ""
                      }`}
                    >
                      {sub.label}
                    </span>
                  </div>
                </li>
              ))}
          </ul>
        )}
      </Popup>
    </>
  );
};

export { Overlay };
export default PopupMenu;
